import { HStack, RadioGroup } from "@chakra-ui/react";
import { SelectOption } from "./utils";
import { t } from "i18next";

export const RadioOptions = ({
  options,
  reverse = false,
}: {
  options: SelectOption[];
  reverse?: boolean;
}) => {
  return (
    <HStack flexWrap={"wrap"} flexDir={reverse ? "row-reverse" : "row"}>
      {options.map((item) => (
        <RadioGroup.Item key={item.value} value={item.value}>
          {reverse && (
            <RadioGroup.ItemText fontWeight={"normal"} fontSize={"xs"}>
              {t(item.translation)}
            </RadioGroup.ItemText>
          )}
          <RadioGroup.ItemHiddenInput />
          <RadioGroup.ItemIndicator />
          {!reverse && (
            <RadioGroup.ItemText fontWeight={"normal"} fontSize={"xs"}>
              {t(item.translation)}
            </RadioGroup.ItemText>
          )}
        </RadioGroup.Item>
      ))}
    </HStack>
  );
};
